export default __webpack_public_path__ + "static/media/ensoconnect.05eb935a.png";